export default __webpack_public_path__ + "static/datwyler-ff2dc8a30c8e1ac4646d25a23d5d2e3f.jpg";